import {EventID, Listener, ListenerPromiseType} from '@gongxigames/framework/core/types';
import {IPromiseEventHelper, PromiseEventMap, PromiseListener} from '@gongxigames/framework/core/types/IPromiseEventHelper';

export class PromiseEventDecorator implements IPromiseEventHelper {
    protected _eventMap: PromiseEventMap<any> = {};

    public emitEvent(id: EventID, ...args: any[]): Promise<void[]> {
        const listeners: PromiseListener<any>[] = this._eventMap[id];

        const promises = listeners
            ?.map(listener => {
                return listener.callback(...args);
            }) || [];

        return Promise.all(promises);
    }

    public onPromise(id: EventID | EventID[], callback: ListenerPromiseType<any>, owner: Object): void {
        const currentEventsMap = this._eventMap;
        const ids = id instanceof Array ? id : [id];

        ids.forEach(id => {
            if (!currentEventsMap[id]) {
                currentEventsMap[id] = [];
            }

            currentEventsMap[id].push({callback, owner});
        });
    }

    public offPromise(id: EventID | EventID[], owner: Object): void {
        const currentEventsMap = this._eventMap;
        const ids = id instanceof Array ? id : [id];

        ids.forEach(id => {
            const listeners: PromiseListener<any>[] = currentEventsMap[id] || [];

            currentEventsMap[id] = listeners.filter( (listener: Listener) => listener.owner !== owner );
        });
    }

    public offAllPromises(owner: Object): void {
        const currentEventsMap = this._eventMap;

        Object.entries(currentEventsMap).forEach(([key, listeners]) => {
            currentEventsMap[key] = listeners.filter( (listener: Listener) => listener.owner !== owner );
        });
    }
}